import Service from '../service'
export var ApiPaymentTerminalMessageType;
(function (ApiPaymentTerminalMessageType) {
  ApiPaymentTerminalMessageType["PAYMENT_TERMINAL_REQUEST"] = "payment.terminal.request"
  ApiPaymentTerminalMessageType["PAYMENT_TERMINAL_RESPONSE"] = "payment.terminal.response"
  ApiPaymentTerminalMessageType["PAYMENT_TERMINAL_STATUS"] = "payment.terminal.status"
})(ApiPaymentTerminalMessageType || (ApiPaymentTerminalMessageType = {}))
export var PaymentTerminalMessageType;
(function (PaymentTerminalMessageType) {
  PaymentTerminalMessageType["STATE_CHANGED"] = "STATE_CHANGED"
  PaymentTerminalMessageType["PAPER_AVAILABILITY"] = "PAPER_AVAILABILITY"
  PaymentTerminalMessageType["ERROR"] = "ERROR"
  PaymentTerminalMessageType["TRANSACTION"] = "TRANSACTION"
  PaymentTerminalMessageType["FINISH"] = "FINISH"
})(PaymentTerminalMessageType || (PaymentTerminalMessageType = {}))
export var PaymentTerminalState;
(function (PaymentTerminalState) {
  /** Ожидание оплаты */
  PaymentTerminalState[PaymentTerminalState["IDLE"] = 0] = "IDLE"
  /** Находится в процессе оплаты */
  PaymentTerminalState[PaymentTerminalState["PROCESS"] = 1] = "PROCESS"
  /** Ошибка */
  PaymentTerminalState[PaymentTerminalState["HAVE_ERROR"] = 2] = "HAVE_ERROR"
  /** Терминал не подключен */
  PaymentTerminalState[PaymentTerminalState["NOT_CONNECTED"] = 3] = "NOT_CONNECTED"
})(PaymentTerminalState || (PaymentTerminalState = {}))
export var PaymentTaxType;
(function (PaymentTaxType) {
  /** Из таблицы отделов */
  PaymentTaxType[PaymentTaxType["TaxVATByDepartment"] = 0] = "TaxVATByDepartment"
  /** НДС 18% */
  PaymentTaxType[PaymentTaxType["TaxVAT18"] = 1] = "TaxVAT18"
  /** НДС 10% */
  PaymentTaxType[PaymentTaxType["TaxVAT10"] = 2] = "TaxVAT10"
  /** НДС 18/118 */
  PaymentTaxType[PaymentTaxType["TaxVAT118"] = 3] = "TaxVAT118"
  /** НДС 10/110 */
  PaymentTaxType[PaymentTaxType["TaxVAT110"] = 4] = "TaxVAT110"
  /** НДС 0% */
  PaymentTaxType[PaymentTaxType["TaxVAT0"] = 5] = "TaxVAT0"
  /** Без НДС */
  PaymentTaxType[PaymentTaxType["TaxVATNo"] = 6] = "TaxVATNo"
  /** НДС 20% */
  PaymentTaxType[PaymentTaxType["TaxVAT20"] = 7] = "TaxVAT20"
  /** НДС 20/120 */
  PaymentTaxType[PaymentTaxType["TaxVAT120"] = 8] = "TaxVAT120"
})(PaymentTaxType || (PaymentTaxType = {}))
/**
 * Сервис для терминала оплаты
 * @version 0.0.1
 * @since 2.6.0
 */
export default class PaymentTerminalService extends Service {
  constructor(messageChannel) {
    super(messageChannel)
    this.waiters = {
      state: [],
      connected: [],
      error: [],
      errorMessage: [],
      sale: [],
      refund: [],
      registerSale: [],
      registerRefund: [],
      nonFiscal: []
    }
    const messageHandler = (message) => {
      switch (message.type) {
        case ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_RESPONSE:
          if (typeof message.state !== 'undefined') {
            this.resolve(this.waiters.state, message.state)
          }
          if (typeof message.connected !== 'undefined') {
            this.resolve(this.waiters.connected, message.connected)
          }
          if (typeof message.error !== 'undefined') {
            this.resolve(this.waiters.error, message.error)
          }
          if (typeof message.errorMessage !== 'undefined') {
            this.resolve(this.waiters.errorMessage, message.errorMessage)
          }
          if (typeof message.sale !== 'undefined') {
            // if false see reason
            this.resolve(this.waiters.sale, message)
          }
          if (typeof message.refund !== 'undefined') {
            // if false see reason
            this.resolve(this.waiters.refund, message)
          }
          if (typeof message.registerSale !== 'undefined') {
            // if false see reason
            this.resolve(this.waiters.registerSale, message)
          }
          if (typeof message.registerRefund !== 'undefined') {
            // if false see reason
            this.resolve(this.waiters.registerRefund, message)
          }
          if (typeof message.nonFiscal !== 'undefined') {
            // if false see reason
            this.resolve(this.waiters.nonFiscal, message)
          }
          break
        case ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_STATUS:
          if (typeof message.stateChanged !== 'undefined') {
            this.broadcast(PaymentTerminalMessageType.STATE_CHANGED)
          }
          if (typeof message.paperAvailability !== 'undefined') {
            this.broadcast(PaymentTerminalMessageType.PAPER_AVAILABILITY, message.paperAvailability)
          }
          if (typeof message.error !== 'undefined') {
            this.broadcast(PaymentTerminalMessageType.ERROR, message.error, message.message)
          }
          if (typeof message.finish !== 'undefined') {
            this.broadcast(PaymentTerminalMessageType.FINISH)
          }
          if (typeof message.transaction !== 'undefined') {
            this.broadcast(PaymentTerminalMessageType.TRANSACTION, message.transaction)
          }
          break
      }
    }
    this.messageChannel.subscribe(ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_RESPONSE, messageHandler)
    this.messageChannel.subscribe(ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_STATUS, messageHandler)
  }
  /**
     * Состояние терминала изменилось
     *
     * @since 2.6.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Состояние терминала изменилось</caption>
     * robot.paymentTerminalService.onStateChanged(() => {
     *   // console.log('IT'S ALIVE!')
     * })
     */
  onStateChanged(callback) {
    return this.subscribe(PaymentTerminalMessageType.STATE_CHANGED, callback)
  }
  /**
     * Наличие бумаги (для чеков)
     *
     * Может быть вызван, если было мало бумаги и она закончилась в момент печати чека
     *
     * @since 2.6.0
     * @param {(state: boolean) => void} callback - True - бумага есть, False - бумаги нет
     * @return {*}  {UnsubscribeFunction}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Наличие бумаги (для чеков)</caption>
     * robot.paymentTerminalService.onPaperAvailability((state) => {
     *   // console.log('PaperAvailability is', state)
     * })
     */
  onPaperAvailability(callback) {
    return this.subscribe(PaymentTerminalMessageType.PAPER_AVAILABILITY, callback)
  }
  /**
     * Внутреннее (C++) состояние ошибки изменилось
     *
     * @since 2.6.0
     * @param {(error: PaymentAndPinPadErrors, message: string) => void} callback - error - код ошибки, message - текст ошибки
     * @return {*}  {UnsubscribeFunction}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Произошла ошибка</caption>
     * robot.paymentTerminalService.onError((error, message) => {
     *    if (error !== PaymentAndPinPadErrors.OK) {
     *      doSomethingWithError(error, message)
     *    }
     * })
     *
     * @example <caption>Состояние ошибки было сброшен</caption>
     * robot.paymentTerminalService.onError((error, message) => {
     *   if (error === PaymentAndPinPadErrors.OK) {
     *     doSomething()
     *   }
     * })
     */
  onError(callback) {
    return this.subscribe(PaymentTerminalMessageType.ERROR, callback)
  }
  /**
     * Произошло завершение текущей операции на терминале
     *
     * Приходит после каждого события
     *
     * @since 2.6.0
     * @param {() => void} callback
     * @return {*}  {UnsubscribeFunction}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Произошло завершение текущей операции на терминале</caption>
     * robot.paymentTerminalService.onFinish(() => {
     *   // console.log('OPERATION END')
     * })
     */
  onFinish(callback) {
    return this.subscribe(PaymentTerminalMessageType.FINISH, callback)
  }
  /**
     * Сервис прислал информацию об ID транзакции эквайринга
     * (необходимо для возврата денег в некоторых банках)
     *
     * @since 2.6.0
     * @param {(transactionId: string) => void} callback - transactionId - ID транзакции эквайринга
     * @return {*}  {UnsubscribeFunction}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Сервис прислал информацию об ID транзакции эквайринга</caption>
     * robot.paymentTerminalService.onTransaction((transactionId) => {
     *   // console.log('ID transaction', transactionId)
     * })
     */
  onTransaction(callback) {
    return this.subscribe(PaymentTerminalMessageType.TRANSACTION, callback)
  }
  /**
     * Открыть смену
     * Метод позволяет принудительно открыть смену, если она не открыта
     *
     * @since 2.6.0
     * @memberof PaymentTerminalService
     *
     * @example <caption>Открыть смену</caption>
     * robot.paymentTerminalService.openSession()
     */
  openSession() {
    this.messageChannel.send({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      openSession: ''
    })
  }
  /**
     * Получить промежуточный X-отчет за смену
     *
     * @since 2.6.0
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить промежуточный X-отчет за смену</caption>
     * robot.paymentTerminalService.reportX()
     */
  reportX() {
    this.messageChannel.send({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      reportX: ''
    })
  }
  /**
     * Получить Z-отчет за смену
     * Метод позволяет получить Z-отчет за смену и закрыть ее
     *
     * @since 2.6.0
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить Z-отчет за смену</caption>
     * robot.paymentTerminalService.reportZ()
     */
  reportZ() {
    this.messageChannel.send({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      reportZ: ''
    })
  }
  /**
     * Получить состояние терминала
     *
     * @since 2.6.0
     * @return {*}  {Promise<PaymentTerminalState>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить состояние терминала</caption>
     * robot.paymentTerminalService.getState().then((state) => {
     * ...
     * }
     */
  getState() {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      state: ''
    }, this.waiters.state)
  }
  /**
     * Получить статус подключения терминала
     *
     * @since 2.6.0
     * @return {*}  {Promise<boolean>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить статус подключения терминала</caption>
     * robot.paymentTerminalService.getConnected().then((connected) => {
     * ...
     * }
     */
  getConnected() {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      connected: ''
    }, this.waiters.connected)
  }
  /**
     * Получить код ошибки терминала
     *
     * @since 2.6.0
     * @return {*}  {Promise<PinPadErrors>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить код ошибки терминала</caption>
     * robot.paymentTerminalService.getError().then((error) => {
     * ...
     * }
     */
  getError() {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      error: ''
    }, this.waiters.error)
  }
  /**
     * Получить текст ошибки терминала
     *
     * @since 2.6.0
     * @return {*}  {Promise<string>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Получить текст ошибки терминала</caption>
     * robot.paymentTerminalService.getErrorMessage().then((errorMessage) => {
     * ...
     * }
     */
  getErrorMessage() {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      errorMessage: ''
    }, this.waiters.errorMessage)
  }
  buildPaymentData(items = [], before = [], after = [], customer_info = null) {
    let data = {}
    if (customer_info !== null) {
      data.customer_info = customer_info
    }
    if (Array.isArray(before)) {
      data.info_before = {}
      before.forEach((line, index) => {
        data.info_before[`line-${ index }`] = line
      })
    }
    if (Array.isArray(after)) {
      data.info_after = {}
      after.forEach((line, index) => {
        data.info_after[`line-${ index }`] = line
      })
    }
    if (Array.isArray(items)) {
      data.items = {}
      items.forEach((item, index) => {
        data.items[`item-${ index }`] = item
      })
    }
    return data
  }
  /**
     * Запустить процесс регистрации покупки в ОФД (вызывается после успешного завершения (finish) метода sale)
     *
     * @since 2.6.0
     * @param {Array<PaymentTerminalSaleItem>} [items=[]] - Данные о товарных позициях в чеке
     * @param {Array<PaymentTerminalInfoItem>} [before=[]] - Строчки в чеке до товарных позиций
     * @param {Array<PaymentTerminalInfoItem>} [after=[]] - Строчки в чеке после товарных позиций
     * @param {(string | null)} [customer_info=null] - данные о покупателе для отправки чека (email или телефон)
     * @return {*}  {Promise<Object>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Запустить процесс регистрации покупки в ОФД</caption>
     * robot.paymentTerminalService.registerSale(items, before, after, customer_info).then((response) => {
     * if (response.registerSale) {
     *  console.log('process successfully started')
     * } else {
     *  console.log('process not started with reason', response.reason)
     *  robot.paymentTerminalService.refund(price, transaction)
     * }
     * }
     */
  registerSale(items = [], before = [], after = [], customer_info = null) {
    let data = this.buildPaymentData(items, before, after, customer_info)
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      registerSale: data
    }, this.waiters.registerSale)
  }
  /**
     * Запустить процесс регистрации возврата в ОФД (вызывается после успешного завершения (finish) метода refund)
     *
     * @since 2.6.0
     * @param {Array<PaymentTerminalSaleItem>} [items=[]] - Данные о товарных позициях в чеке
     * @param {Array<PaymentTerminalInfoItem>} [before=[]] - Строчки в чеке до товарных позиций
     * @param {Array<PaymentTerminalInfoItem>} [after=[]] - Строчки в чеке после товарных позиций
     * @param {(string | null)} [customer_info=null] - данные о покупателе для отправки чека (email или телефон)
     * @return {*}  {Promise<Object>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Запустить процесс регистрации возврата в ОФД</caption>
     * robot.paymentTerminalService.registerRefund(items, before, after, customer_info).then((response) => {
     * if (response.registerRefund) {
     *  console.log('process successfully started')
     * } else {
     *  console.log('process not started with reason', response.reason)
     * }
     * }
     */
  registerRefund(items = [], before = [], after = [], customer_info = null) {
    let data = this.buildPaymentData(items, before, after, customer_info)
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      registerRefund: data
    }, this.waiters.registerRefund)
  }
  /**
     * Напечатать нефискальный документ на чековом принтере
     *
     * @since 2.6.0
     * @param {Array<PaymentTerminalInfoItem>} [items=[]]
     * @return {*}  {Promise<Object>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Напечатать нефискальный документ</caption>
     * robot.paymentTerminalService.nonFiscal(items).then((response) => {
     * if (response.nonFiscal) {
     *  console.log('process successfully started')
     * } else {
     *  console.log('process not started with reason', response.reason)
     * }
     * }
     */
  nonFiscal(items = []) {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      nonFiscal: { items: items }
    }, this.waiters.nonFiscal)
  }
  /**
     * Запустить процесс оплаты (при оплате вызывается первым)
     *
     * Если сессия была закрыта, то автоматически откроет ее
     *
     * Работа с эквайрингом
     *
     * @since 2.6.0
     * @param {number} [price=0.0] - Сумма оплаты (в рублях)
     * @return {*}  {Promise<Object>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Запустить процесс оплаты</caption>
     * robot.paymentTerminalService.sale(price).then((response) => {
     * if (response.sale) {
     *  console.log('process successfully started')
     * } else {
     *  console.log('process not started with reason', response.reason)
     * }
     * }
     */
  sale(price = 0.0) {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      sale: { price: price }
    }, this.waiters.sale)
  }
  /**
     * Запустить процесс возврата покупки (при возврате вызывается первым)
     *
     * Работа с эквайрингом
     *
     * @since 2.6.0
     * @param {number} [price=0.0] - Сумма возврата (в рублях)
     * @param {string} [transaction=''] - ID транзакции эквайринга (необходимость уточнять у банка выдавшего терминал)
     * @return {*}  {Promise<Object>}
     * @memberof PaymentTerminalService
     *
     * @example <caption>Запустить процесс возврата покупки</caption>
     * robot.paymentTerminalService.refund(price, transaction).then((response) => {
     * if (response.refund) {
     *  console.log('process successfully started')
     * } else {
     *  console.log('process not started with reason', response.reason)
     * }
     * }
     */
  refund(price = 0.0, transaction = '') {
    return this.execute({
      type: ApiPaymentTerminalMessageType.PAYMENT_TERMINAL_REQUEST,
      refund: { price: price,
        transaction: transaction }
    }, this.waiters.refund)
  }
}
